import React from "react";
import CircularSpinner from "./CircularSpinner";
import loadable from "@loadable/component";
import { jsx as _jsx } from "react/jsx-runtime";
export default (function (load) {
  var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Loading";
  return loadable(load, {
    fallback: /*#__PURE__*/_jsx(CircularSpinner, {
      label: label
    })
  });
});
//# sourceMappingURL=loadable.js.map